module.exports = __webpack_public_path__ + "assets/img/mine1.03092165.png";